/* eslint-disable react/prop-types */ // TODO: add props
import { IndicatorCell, INDICATOR_TYPES } from '../../../../../components';
import { RowExpansionArrow } from '../../../components/Icons';
import { IllustrationQuestion } from 'edrolo/domains/exams/components/Question/components/IllustrationQuestion';
import {
  correctableQuestionPropTypes,
  CorrectableQuestionReview,
} from './CorrectableQuestionReview';
import {
  name,
  selfReflection,
} from '../../../components/TableColumns/TableColumns';

import style from './styles.scss';

const IllustrationQuestionReview = ({
  question,
  getStudentCourseProgressUrl,
  ...restProps
}) => {
  const expander = {
    id: 'expander',
    Header: '',
    style: { width: '24px' },
    Cell: ({ row }) =>
      row.original.getIn(['response', 'field_responses', 0]) ? (
        <div
          className={style.expanderWidgetContainer}
          {...row.getToggleRowExpandedProps()}
        >
          {row.isExpanded ? (
            <RowExpansionArrow expanded />
          ) : (
            <RowExpansionArrow />
          )}
        </div>
      ) : null,
  };

  const studentResponseColumn = {
    id: 'studentResponse',
    Header: 'Student Response',
    accessor: (row) => {
      return {
        response: row.get('response'),
      };
    },

    Cell: ({ cell, row }) => {
      const { response } = cell.value;

      return response && response.get('field_responses').size > 0 ? (
        <div {...row.getToggleRowExpandedProps()}>
          {row.isExpanded ? (
            <div className={style.responseWrapper}>
              <IllustrationQuestion
                question={question}
                response={response}
                isQuestionReview
              />
            </div>
          ) : (
            <div className={style.responseWrapper}>
              <span>View student response</span>
            </div>
          )}
        </div>
      ) : (
        <IndicatorCell
          value={'Not answered'}
          indicatorType={INDICATOR_TYPES.NEUTRAL}
        />
      );
    },

    sortType: (rowA, rowB) => {
      let isAnsweredA = null;
      let isAnsweredB = null;
      const responseA = rowA.original.get('response');
      const responseB = rowB.original.get('response');

      if (responseA && responseA.get('field_responses').size > 0) {
        isAnsweredA = true;
      }
      if (responseB && responseB.get('field_responses').size > 0) {
        isAnsweredB = true;
      }

      const isCorrectSortOrder = [true, null];

      if (
        isCorrectSortOrder.indexOf(isAnsweredA) >
        isCorrectSortOrder.indexOf(isAnsweredB)
      ) {
        return 1;
      }

      return -1;
    },
  };

  const studentSelfMarks = {
    id: 'studentMark',
    Header: 'Student Mark',
    accessor: (row) => {
      const studentMarks = (+row.getIn([
        'response',
        'text_marks_from_student',
      ])).toFixed(0);
      if (studentMarks && !isNaN(studentMarks)) {
        return `${studentMarks}/${(+question?.get('marks')).toFixed(0)}`;
      }

      return 'N/A';
    },
    sortType: (rowA, rowB) =>
      rowA.original.getIn(['response', 'marks_final']) >
      rowB.original.getIn(['response', 'marks_final'])
        ? 1
        : -1,
  };

  return (
    <CorrectableQuestionReview
      question={question}
      nameColumn={{
        ...name(getStudentCourseProgressUrl),
      }}
      studentResponseColumnSpec={{
        ...studentResponseColumn,
        style: { width: '50%' },
      }}
      studentSelfMarks={studentSelfMarks}
      selfReflectionColumn={selfReflection}
      expanderColumn={expander}
      checklist
      showChart
      {...restProps}
    />
  );
};

export default IllustrationQuestionReview;

IllustrationQuestionReview.propTypes = correctableQuestionPropTypes;
